require('./authorizeBizumStep3.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

//@core
const { formatText } = require('core/i18n').i18n;

//@commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');

//@components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

class AuthorizeBizumStep3 extends React.Component {
    constructor(props) {
        super(props);
        this.handleAcceptTermsAndConditions = this.handleAcceptTermsAndConditions.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.state = {
            showModal: false
        };

    }

    componentWillReceiveProps(nextProps){
        const hasError = !!nextProps.immStep.get('error');
        if(this.state.showModal != hasError){
            this.setState({showModal:hasError});
        }
    }

    handleAcceptTermsAndConditions(){
        const {onAcceptTermsAndConditions, immStep} = this.props;
        onAcceptTermsAndConditions(!immStep.get('terms'));
    }

    handleCancelModal(){
        this.props.onSetError();
    }

    handleCancelAlta(){
        this.props.history.push('/myprofile/transfers');
    }

    buildModal () {
        const confirmTitle = formatText("authorizeBizumStep3-confirmationTitleCancelAlta")
        const confirmDescription = formatText("authorizeBizumStep3-confirmationMessageCancelAlta");
        const cancelAltaButton = formatText("authorizeBizumStep3-cancelAltaButton");
        return (
            <PreleaveCancelModal
                confirmTitle={confirmTitle}
                isOpen={this.state.showModal}
                onCancel={() => this.handleCancelAlta()}
                cancelButtonLabel={cancelAltaButton}
                onCloseModal={this.handleCancelModal}
            >
                <BlockInfo extraClass="authorize-bizum-step3__block-info no-print-out">
                    <div>
                        {confirmDescription}
                    </div>
                </BlockInfo>
            </PreleaveCancelModal>
        );
    }

    render(){
        const { immStep } = this.props;
        const termsAndConditionsAccepted = immStep.get('terms');

        const title = formatText("authorizeBizumStep3-title");
        const firstMessage = formatText("authorizeBizumStep3-message1");
        const titleFirtsDocument = formatText("authorizeBizumStep3-titleDocument1");
        const titleSecondDocument = formatText("authorizeBizumStep3-titleDocument2");
        const titleThirdDocument = formatText("authorizeBizumStep3-titleDocument3");
        const secondMessage = formatText("authorizeBizumStep3-message2");
        const labelAcceptTermsAndConditionsCheckBox = formatText('authorizeBizumStep3-acceptTermsAndConditionsCheckbox');
        const modal = this.buildModal();
        return (
            <div className="authorize-bizum-step3">
                <h4 className="wizard-step--vertical__title">{title}</h4>
                <div className="authorize-bizum-step3__content">
                    <div className="authorize-bizum-step3__left-column">
                        <BlockInfo extraClass="authorize-bizum-step3__block-info">
                            <div>
                                <p>{firstMessage}</p><br/>
                                <p>{titleFirtsDocument}</p><br/>
                                <p>{titleSecondDocument}</p><br/>
                                <p>{titleThirdDocument}</p>
                            </div>
                        </BlockInfo>
                        <BlockInfo extraClass="authorize-bizum-step3__block-info no-print-out">
                            <div>
                                <p>{secondMessage}</p>
                            </div>
                        </BlockInfo>
                    </div>
                    <div className="authorize-bizum-step3__right-column">
                        <div>
                            <OKCheckbox
                                idName="termsAndConditions"
                                value={termsAndConditionsAccepted}
                                onChange={this.handleAcceptTermsAndConditions}
                                label={labelAcceptTermsAndConditionsCheckBox}
                            />
                        </div>
                    </div>
                </div>
                {modal}
            </div>
        )
    }
}

AuthorizeBizumStep3.propTypes = {
    history: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    onSetError: PropTypes.func.isRequired,
    onAcceptTermsAndConditions: PropTypes.func.isRequired

}

module.exports = withRouter(AuthorizeBizumStep3);
